export const IconTriangleLeft = () => (
  <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_dd)">
      <path fillRule="evenodd" clipRule="evenodd" d="M19 4L5 11.9999L19 19.9999V4Z" stroke="url(#paint0_linear)" />
    </g>
    <defs>
      <filter
        id="filter0_dd"
        x="0.992188"
        y="0.138412"
        width="23.5078"
        height="25.723"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dx="2" dy="2" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0392157 0 0 0 0 0.129412 0 0 0 0 0.2 0 0 0 0.44 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dx="-1" dy="-1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.698039 0 0 0 0 0.835294 0 0 0 0 0.188235 0 0 0 0.3 0" />
        <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear"
        x1="-28"
        y1="-2.99995"
        x2="-5.52036"
        y2="-16.7853"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DBF1C1" />
        <stop offset="0.489583" stopColor="#DBF1C1" stopOpacity="0.3" />
        <stop offset="1" stopColor="#DBF1C1" />
      </linearGradient>
    </defs>
  </svg>
)
